import React from 'react';
import { Chip } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';

const ENABLED = process.env.REACT_APP_DEV_LABELS === 'true';

/**
 * DevBadge — shows a floating label to identify a page or modal during development.
 * Only rendered when REACT_APP_DEV_LABELS=true in the frontend .env file.
 *
 * Usage on a page:   <DevBadge id="page:admin-dashboard" />
 * Usage in a modal:  <DevBadge id="modal:edit-user" inline />
 */
export default function DevBadge({ id, inline = false }) {
  if (!ENABLED) return null;

  if (inline) {
    return (
      <Chip
        icon={<CodeIcon sx={{ fontSize: '0.75rem !important' }} />}
        label={id}
        size="small"
        sx={{
          ml: 1.5,
          height: 20,
          fontSize: '0.65rem',
          fontFamily: 'monospace',
          bgcolor: 'rgba(255,152,0,0.15)',
          color: '#e65100',
          border: '1px solid rgba(230,81,0,0.35)',
          '& .MuiChip-label': { px: 0.75 },
          verticalAlign: 'middle',
        }}
      />
    );
  }

  return (
    <Chip
      icon={<CodeIcon sx={{ fontSize: '0.75rem !important' }} />}
      label={id}
      size="small"
      sx={{
        position: 'fixed',
        bottom: 16,
        right: 16,
        zIndex: 9999,
        fontFamily: 'monospace',
        fontSize: '0.65rem',
        height: 22,
        bgcolor: 'rgba(255,152,0,0.12)',
        color: '#e65100',
        border: '1px solid rgba(230,81,0,0.4)',
        backdropFilter: 'blur(4px)',
        boxShadow: '0 1px 6px rgba(0,0,0,0.15)',
        '& .MuiChip-label': { px: 0.75 },
        pointerEvents: 'none',
      }}
    />
  );
}
